import MenuDropdown from "@Components/MenuDropdown";
import { RoomTypeFilterProps } from "../../types";
// import PopoverFilter from "./PopOverFilter";

import classes from "./Filter.module.scss";
import RadioButton from "@Components/Radio";
import themeVariables from "@Theme/exportColor.module.scss";
import ArrowIcon from "@Icons/ArrowIcon";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const RoomTypeFilterDesktop = ({
  selectedConfig,
  isSelected,
  roomTypes,
  handleFilterChange,
}: RoomTypeFilterProps) => {
  const getRoomName = () => {
    const roomName = roomTypes.filter((room) => selectedConfig === room.value)[0]?.name;
    return t(roomName);
  };
  const { t } = useTranslationHook();
  return (
    <>
      {/* <button
        className={classes.buttonContainer}
        type="button"
        style={{
          borderColor: isSelected ? themeVariables.primary4 : "rgb(209, 213, 219)",
          color: isSelected ? themeVariables.primary4 : "rgb(55, 65, 81)",
        }}
        onClick={() => setShowPopup((prev) => !prev)}
      >
        <div className={classes.titleText}>{!isSelected ? " All Room Types" : getRoomName()}</div>
        <ArrowIcon stroke={isSelected ? themeVariables.primary4 : themeVariables.neutral8} />
      </button> */}

      {/* <select
        // value={!isSelected ? " All Room Types" : getRoomName()}
        className={classes.optionsContainer}
      >
        {(roomTypes || []).map((room: any) => (
          <option
            className={classes.option}
            onClick={() => {
              handleFilterChange(room.value);
            }}
            value={room.value}
          >
            <RadioButton isSelected={selectedConfig === room.value} />
            <div key={room.value} color="primary.4" className={classes.buttonWrapper}>
              {room.name}
            </div>
          </option>
        ))}
      </select> */}
      <MenuDropdown
        target={
          <button
            data-testid="All-Room-Types-Dropdown"
            className={classes.buttonContainer}
            type="button"
            style={{
              borderColor: themeVariables.neutral2,
              color: themeVariables.neutral7,
            }}
            id="roomTypeDesktopBtn"
          >
            <div className={classes.titleText}>
              {!isSelected
                ? t("propertypage.components.pricetrends.filters.allRoomTypes")
                : getRoomName()}
            </div>
            <ArrowIcon stroke={isSelected ? themeVariables.neutral7 : themeVariables.neutral8} />
          </button>
        }
        menuContainerClassName={classes.menuClass}
        menu={
          <div className={classes.desktopOptionsDiv}>
            <div
              data-testid="property-price-trend-filter-modal-name"
              className={classes.modalTitle}
            >
              {t("Room Type")}
            </div>
            <div className={classes.optionsContainerDesktop}>
              {(roomTypes || []).map((room: any) => (
                <div
                  data-testid="property-price-trend-filter"
                  className={classes.optionDesktop}
                  onClick={() => {
                    handleFilterChange(room.value);
                  }}
                  role="radio"
                  aria-checked={selectedConfig === room.value}
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === " ") {
                      handleFilterChange(room.value);
                    }
                  }}
                  key={room.value}
                >
                  <RadioButton isSelected={selectedConfig === room.value} />
                  <div
                    data-testid="property-price-trend-room-name"
                    key={room.value}
                    color="primary.4"
                    className={classes.buttonWrapper}
                  >
                    {t(room.name)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
    </>
  );
};

export default wrapperHOC(RoomTypeFilterDesktop, {
  componentName: "RoomTypeFilterDesktop-Filters-PriceTrends-PropertyPage",
  showForChina: true,
});
